(function() { window.GUID_39be37e3_05ba_481a_ab6b_752fa02ef01b = { getGuid: function() { return "39be37e3-05ba-481a-ab6b-752fa02ef01b"; } }; })();
////namespace CS.App.Views._Shared.WallSections {
////    CS.Controls.Accordion.Events.Ready({
////        selector: "body",
////        childSelector: ".accordion-operatorplayers",
////        callback: function (control, e) {
////            control.$Container.offon("click.player-box", ".operator-player-row", function (e) {
////                const $target = $(e.target)
////                alert('test');
////            });
////        }
////    });
////}

//# sourceMappingURL=operator-player-row.js.map
